function isPhoneNumberValid(number: string): boolean {
  return !((number as unknown as number) < 999999999 && number !== '');
}

const PHONE_REG_EXP =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export { isPhoneNumberValid, PHONE_REG_EXP };
